<template>
  <div class="transfer-container">
    <div class="transfer-card">
      <!-- 余额展示 -->
      <div class="balance-grid">
        <div class="balance-item">
          <span class="balance-label">{{ $t('_h._ye') }}</span>
          <span class="balance-value">${{ wallet.balance || 0 }}</span>
        </div>
        <div class="balance-item video-balance">
          <span class="balance-label">{{ $t('_sp._dbye') }}</span>
          <span class="balance-value">${{ wallet.video || 0 }}</span>
        </div>
      </div>

      <!-- 金额选择 -->
      <div class="amount-section">
        <div class="amount-header">
          <span class="amount-title">{{ $t('_sp._txje') }}</span>
        </div>
        <div class="amount-options">
          <button v-for="(item, i) in amountOptions" :key="i" class="amount-btn" :class="{ active: index === i + 1 }" @click="selectAmount(i + 1, item)">${{ item }}</button>
        </div>
        <!-- 自定义金额 -->
        <div class="custom-amount">
          <input v-model="customAmount" type="number" class="amount-input" :placeholder="$t('_sp._qsrtxje')" @input="onCustomInput" readonly />
          <span class="input-suffix">USD</span>
        </div>
      </div>

      <!-- 提示信息 -->
      <div class="transfer-tip">
        <i class="fas fa-info-circle"></i>
        <span>{{ $t('_nhz._sm') }}</span>
      </div>

      <!-- 操作按钮 -->
      <div class="action-buttons">
        <button class="btn-back" @click="onBack('wallet')">
          <i class="fas fa-arrow-left"></i>
          {{ $t('_sp._fanh') }}
        </button>
        <button class="btn-transfer" @click="onTransfer" :disabled="!canTransfer">
          <i class="fas fa-exchange-alt"></i>
          {{ $t('_sp._ljhz') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransferVue',
  data() {
    return {
      wallet: {},
      index: 1,
      amountOptions: [299, 399, 599],
      customAmount: 299,
      params: {
        number: 299
      }
    }
  },
  computed: {
    canTransfer() {
      const num = Number(this.params.number)
      return num > 0 && num <= (this.wallet.balance || 0)
    }
  },
  created() {
    this.getWallet()
  },
  methods: {
    onBack(name) {
      this.$router.push({ name: name })
    },

    selectAmount(index, amount) {
      this.index = index
      this.customAmount = amount
      this.params.number = amount
    },

    onCustomInput() {
      const val = Number(this.customAmount)
      if (val > 0) {
        this.index = 0
        this.params.number = val
      }
    },

    getWallet() {
      this.$api.userWallet.getWallet().then((res) => {
        if (res.data) {
          this.wallet = res.data
        }
      })
    },

    onTransfer() {
      const amount = Number(this.params.number)

      if (!amount || amount <= 0) {
        this.$message.error(this.$t('_sp._qshuru'))
        return
      }

      if (amount > (this.wallet.balance || 0)) {
        this.$message.error(this.$t('_sp._yebz'))
        return
      }

      const hide = this.$message.loading({ content: this.$t('_nhz._zhzz'), key: 'msg' })

      this.$api.userWallet
        .transfer({ number: amount })
        .then((res) => {
          hide()
          if (res.data?.code <= 0) {
            this.$message.error(res.data?.msg)
            return
          }
          this.$message.success(this.$t('_nhz._zzcg'))
          this.getWallet()
          this.params.number = ''
          this.customAmount = ''
          this.index = 0
        })
        .catch(() => {
          hide()
          this.$message.error(this.$t('_nhz._zhzsb'))
        })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   转账页面 - 深灰主题
   ============================================================ */

.transfer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 40px;
}

.transfer-card {
  max-width: 560px;
  margin: 0 auto;
  background: #1a1f26;
  border-radius: 16px;
  border: 1px solid #2a3038;
  padding: 32px 36px 28px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

/* ============================================================
   余额展示
   ============================================================ */
.balance-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 28px;
}

.balance-item {
  background: #0f1419;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid #2a3038;
  text-align: center;
}

.balance-item.video-balance {
  border-color: rgba(255, 179, 0, 0.2);
}

.balance-label {
  display: block;
  font-size: 13px;
  color: #6a7a8a;
  font-weight: 500;
  margin-bottom: 4px;
}

.balance-value {
  display: block;
  font-size: 26px;
  font-weight: 700;
  color: #e8edf2;
}

.balance-item.video-balance .balance-value {
  color: #ffb300;
}

/* ============================================================
   金额选择
   ============================================================ */
.amount-section {
  margin-bottom: 24px;
}

.amount-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.amount-title {
  font-size: 15px;
  font-weight: 600;
  color: #e8edf2;
}

.amount-options {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 12px;
}

.amount-btn {
  padding: 10px 0;
  border: 2px solid #2a3038;
  border-radius: 10px;
  background: transparent;
  color: #8a949f;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.amount-btn:hover {
  border-color: #ffb300;
  color: #e8edf2;
}

.amount-btn.active {
  border-color: #ffb300;
  background: rgba(255, 179, 0, 0.12);
  color: #ffb300;
}

/* ============================================================
   自定义金额
   ============================================================ */
.custom-amount {
  display: flex;
  align-items: center;
  background: #0f1419;
  border-radius: 10px;
  border: 1px solid #2a3038;
  transition: border-color 0.3s;
}

.custom-amount:focus-within {
  border-color: #ffb300;
  box-shadow: 0 0 0 3px rgba(255, 179, 0, 0.08);
}

.amount-input {
  flex: 1;
  padding: 12px 16px;
  background: transparent;
  border: none;
  outline: none;
  color: #e8edf2;
  font-size: 16px;
  font-weight: 500;
}

.amount-input::placeholder {
  color: #4a5662;
  font-weight: 400;
}

.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input-suffix {
  padding: 0 16px;
  color: #6a7a8a;
  font-size: 14px;
  font-weight: 500;
}

/* ============================================================
   提示信息
   ============================================================ */
.transfer-tip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(255, 179, 0, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(255, 179, 0, 0.08);
  margin-bottom: 24px;
}

.transfer-tip i {
  color: #ffb300;
  font-size: 16px;
  flex-shrink: 0;
}

.transfer-tip span {
  font-size: 13px;
  color: #8a949f;
  line-height: 1.5;
}

/* ============================================================
   操作按钮
   ============================================================ */
.action-buttons {
  display: flex;
  gap: 12px;
}

.btn-back {
  flex: 1;
  padding: 12px 20px;
  border: 1px solid #2a3038;
  border-radius: 10px;
  background: transparent;
  color: #8a949f;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.04);
  border-color: #3a4652;
  color: #e8edf2;
}

.btn-transfer {
  flex: 2;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-transfer:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

.btn-transfer:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 640px) {
  .transfer-container {
    padding: 12px;
  }

  .transfer-card {
    padding: 20px 18px 20px;
    border-radius: 12px;
  }

  .balance-grid {
    gap: 10px;
  }

  .balance-item {
    padding: 12px 14px;
  }

  .balance-value {
    font-size: 22px;
  }

  .amount-options {
    gap: 8px;
  }

  .amount-btn {
    font-size: 16px;
    padding: 8px 0;
  }

  .amount-input {
    font-size: 15px;
    padding: 10px 14px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-back,
  .btn-transfer {
    padding: 12px 16px;
    font-size: 14px;
  }
}

@media (max-width: 400px) {
  .transfer-card {
    padding: 16px 12px 16px;
  }

  .balance-value {
    font-size: 18px;
  }

  .balance-label {
    font-size: 11px;
  }

  .amount-btn {
    font-size: 14px;
    padding: 6px 0;
  }

  .amount-input {
    font-size: 14px;
    padding: 8px 12px;
  }

  .input-suffix {
    font-size: 12px;
    padding: 0 12px;
  }
}
</style>
